/**
 * Created by fers on 05.02.16.
 */
/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import Link from 'react-router/lib/Link';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import * as Tool from '../fw/Tool';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddonAdd.title', 'defaultMessage': 'Adding Application Addon'},
});

interface ChannelAddonAddStep1Props {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelAddonAddStep1 extends React.Component<ChannelAddonAddStep1Props> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'addonDefs';

    constructor(props) {
        super(props);
    }

    render() {
        let type = types[this.typeName];
        const {channel} = this.props.user.organisation;
        let {addonDef} = this.props.user;

        let longDescription = Tool.getDataForColumn('description', type.fields(), addonDef);

        if (longDescription) {
            longDescription = Tool.tranformDataForView('addonDefs', type.fields('description'), this.props.intl.formatMessage, longDescription, false, 0);
        }

        let tagsTag = null;
        let columnMapping = Tool.getMappingForColumn('state', type.fields());
        let tags = Tool.getDataForColumn('state', type.fields(), addonDef);
        if (tags) {
            if (!('hide' in columnMapping['values'][tags]) && !columnMapping['values'][tags].hide) {
                let style = {};
                if (columnMapping['values'][tags].color) {
                    style['backgroundColor'] = columnMapping['values'][tags].color;
                }
                tagsTag = (
                    <span className="badge" style={style}>{Tool.tranformDataForView(type.entity(), columnMapping, this.props.intl.formatMessage, tags, true)}</span>);
            }
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: type, data: addonDef},
                {type: types['organisations'], data: this.props.user.organisation},
                {type: types['channels'], data: channel},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <div className="flex-row ChannelHeader">
                    <div className="flex flex-row">
                        <div className="flex-nogrow flex-column">
                            <span className="flex"></span>
                            <ChannelIcon channelDef={addonDef.channelDef ? addonDef.channelDef : {icon: 'dativery'}} className="channelViewMainIcon" size={128}/>
                            <span className="flex"></span>
                        </div>
                        <div className="flex flex-column">
                            <span className="flex"></span>
                            <h2> {addonDef.name} {tagsTag}</h2>

                            <span className="flex"></span>
                        </div>
                    </div>
                </div>

                <p>{longDescription}</p>

                <Link className="btn btn-primary" to={urlMapping.getUrl(types['channelAddons'], 'create-step-2', {
                    organisation_id: this.props.user.organisation.realId,
                    channel_id: this.props.user.organisation.channel.realId,
                    addonDef_id: this.props.user.addonDef['realId']
                })}><FormattedMessage defaultMessage="Start using " id="addonDef.startUsingFor" />{" "}{addonDef.name}</Link>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddonAddStep1), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.addonDef;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        addonDefId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        realId,
                        name,
                        organisation_id,
                        channelDef_id,
                        channelDef {
                            id,
                            name,
                        }
                    }
                },
                addonDef(id: $addonDefId) {
                    id,
                    realId,
                    name,
                    description,
                    state,
                    allowConnectedChannelSelection,
                    channelDef {
                        id,
                        name,
                        icon
                    }
                }
            }
        `,
    },
});
